import { IPolygonV2WorldMarker, IPolygonWorldMarker } from 'react-give-me-map';
import { EWorldColor } from 'static/config/worldVariables';

export const TRANSPARENT_POLYGON_V1_DASH_ARRAY = '8,8';
export const TRANSPARENT_POLYGON_V1_COLOR = '000';

export function mapPolygonForEdit(marker: IPolygonWorldMarker) {
    if (marker.elementData.color === EWorldColor.TRANSPARENT) {
        return {
            ...marker,
            elementData: {
                ...marker.elementData,
                color: TRANSPARENT_POLYGON_V1_COLOR,
                strokeDashArray: TRANSPARENT_POLYGON_V1_DASH_ARRAY
            }
        };
    }
    return marker;
}

export function mapPolygonV2ForEdit(marker: IPolygonV2WorldMarker): IPolygonV2WorldMarker {
    const isTransparent = !marker.elementData.border.hasBorder && !marker.elementData.fill.isFilled;
    if (isTransparent) {
        return {
            ...marker,
            elementData: {
                ...marker.elementData,
                border: {
                    hasBorder: true,
                    width: 2,
                    opacity: 0.5,
                    color: '#000',
                    rawPaintAttributes: {
                        'line-dasharray': [8, 8]
                    },
                    rawLayoutAttributes: {}
                }
            }
        };
    }
    return marker;
}
